import { render, staticRenderFns } from "./ValFormGroup.vue?vue&type=template&id=7e83f874&"
import script from "./ValFormGroup.vue?vue&type=script&lang=ts&"
export * from "./ValFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports